import { useState, FormEvent, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";

import { RenderFields } from "../../../shared/utils/render-fields";
import "./popup.scss";
import { createUUID } from "../../../shared/utils/utils";
import { IFieldConfigDefinition } from "../../../shared/definitions/field";
import { ITableRowData } from "../data-table/data-table";

export interface IPopupConfig {
  mode: string;
  buttonText: string;
  columns: IFieldConfigDefinition[];
  values: ITableRowData | undefined;
  show: boolean;
  handlePopupClosed(result: ITableRowData | undefined): void;
}

const Popup = ({ 
  mode,
  show,
  buttonText,
  columns: colums,
  values,
  handlePopupClosed
}: IPopupConfig ) => {
  const [data, setData] = useState<ITableRowData>(values || {id: createUUID()}
  );
  const [validated, setValidated] = useState(false);
  const [showPopup, setShowPopup] = useState(show);

  useEffect(() => {
    setShowPopup(show);

    if (values) {
      setData(values);
    } else {
      setData({id: createUUID()});
    }
  }, [show]);

  const handleOnChange = (targetVal: string, inputKey: string) => {
    setData({...data, [inputKey]: targetVal});
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;
    
    event.preventDefault();

    if (form.checkValidity() !== true) {
      setValidated(true);
      return;
    }
    if (!data) {
      return;
    }
    const copyData = {...data};
    handlePopupClosed(copyData);
    setValidated(false);
  };

  return (
    <div className="popup">
      <Modal show={showPopup} onHide={() => handlePopupClosed(undefined)}>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>{mode}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RenderFields mode={mode} fields={colums} data={data} handleOnChange={handleOnChange} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => handlePopupClosed(undefined)}
            >
              Close
            </Button>
            <Button
              className="popup-action"
              type="submit"
              variant="primary"
            >
              {buttonText}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default Popup;